import { AddPhotoControlNew } from "./ui/AddPhotoControlNew";

export default AddPhotoControlNew;import { AddPhotoControlNew } from "./ui/AddPhotoControlNew";

export default AddPhotoControlNew;